// extracted by mini-css-extract-plugin
module.exports = {"CreateAccount":"_hRnA","MinHeight":"_1acHP","container768":"UmyAf","topSpace80":"_1vukr","title":"_1aB7o","congratulations":"tYMAU","topSpace50":"_147uV","nextButton":"_2SXFX"};